/* ================================================= */
/* ASSISTANT STREAM PARSER                           */
/* Stateful SSE event parser for fetch streams.      */
/*                                                   */
/* Handles partial events that span multiple chunks. */
/* SSE events are delimited by \n\n.                */
/*                                                   */
/* Usage:                                            */
/*   const parser = createSSEParser();               */
/*   const events = parser.push(rawText);            */
/*   // events: [{ type, data }]                     */
/* ================================================= */

/**
 * createSSEParser — creates a stateful parser for SSE streams.
 *
 * Each call to push() returns an array of fully-parsed events.
 * Partial events are buffered until the next \n\n delimiter arrives.
 */
export function createSSEParser() {
  let buffer = "";

  return {
    push(text) {
      buffer += text;
      const events = [];

      // Events are separated by blank lines (\n\n)
      const parts = buffer.split("\n\n");
      // Last part may be incomplete — keep it in the buffer
      buffer = parts.pop() ?? "";

      for (const part of parts) {
        if (!part.trim()) continue;

        let eventType = "message";
        let dataStr   = "";

        for (const line of part.split("\n")) {
          if (line.startsWith("event: ")) {
            eventType = line.slice(7).trim();
          } else if (line.startsWith("data: ")) {
            dataStr = line.slice(6).trim();
          }
        }

        if (!dataStr) continue;

        try {
          const data = JSON.parse(dataStr);
          events.push({ type: eventType, data });
        } catch {
          // Skip malformed events silently
        }
      }

      return events;
    },

    reset() {
      buffer = "";
    },
  };
}
